import { render } from "./inventory_turn_over.vue?vue&type=template&id=68f229a3"
import script from "./inventory_turn_over.vue?vue&type=script&lang=js"
export * from "./inventory_turn_over.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__